var render = function render(){var _vm=this,_c=_vm._self._c;return _c('StandardIconBloc',{attrs:{"icon":"chat-quote-fill","backColor":"rgb(232,232,232)","frontColor":"rgb(88,88,88)"}},[_c('em',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }